<template>
  <div
    v-if="loading"
    class="ma-5 text-xs-center"
  >
    <v-progress-circular
      indeterminate
      :size="32"
      color="accent"
    />
  </div>
  <div
    v-else
    layout="column"
  >
    <div
      layout="row"
      class="subheading font-weight-light ml-2 mb-4"
    >
      Evaluation forms
    </div>
    <div
      layout="row"
      layout-align="center center"
      class="pl-5 pr-5 ml-5 mr-5"
    >
      <div
        layout="column"
        flex="100"
      >
        <v-select
          v-model="topic"
          v-focus
          outline
          autocomplete
          label="Concept"
          :items="topics"
          item-text="name"
          item-value="id"
        />
        <v-select
          v-model="dataType"
          v-focus
          outline
          label="Evaluation type"
          :items="dataTypes"
        />
        <div class="text-xs-right">
          <v-btn
            depressed
            color="primary"
            :disabled="loading || !topic"
            @click="exportExcel"
          >
            Export
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Statistics from '@/api/statistics'
import Params from '@/api/params'
import Consts from '@/consts'

export default {
  props: ['start', 'end', 'toFilter'],
  data () {
    return {
      loading: false,
      dataType: 1,
      dataTypes: [
        { value: 1, text: 'Daggesrapports' },
        { value: 2, text: 'Individual evaluations' },
        { value: 3, text: 'Intern evaluations' }
      ],
      topics: [],
      topic: null
    }
  },
  watch: {
    toFilter (val) {
      if (val) {
        this.$emit('update:toFilter', false)
      }
    },
  },
  mounted () {
		this.fetchParams()
  },
  methods: {
		fetchParams(){
			Params.getList('topics', {is_enabled: 1, application: Consts.APPLICATION.FREELANCES}).then(res => {
					this.topics = res.data
			})
		},
		exportExcel () {
      this.loading = true
      Statistics.exportEvals({ start: this.start, end: this.end, topic_id: this.topic, eval_type: this.dataType }).then(res => {
        this.loading = false
        let blob = new Blob([res.data], { type: "octet/stream" })

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, 'Export-evaluations-' + this.start + '-' + this.end + ".xlsx")
        } else {
          let a = document.createElement("a")
          document.body.appendChild(a)
          a.style = "display: none"
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = 'Export-evaluations-' + this.start + '-' + this.end + ".xlsx"
          a.click()
          window.URL.revokeObjectURL(url)
        }
      })
    }
  }
}
</script>
<style scoped>
.number-color {
  color: #f4b944;
}
</style>